module.exports = __webpack_public_path__ + "img/10_41.88ebef82.png";